<header class="topbar-header" [ngClass]="{ active: sidebarOpen }">
  <div class="topbar shadow-sm">
    <nav class="navbar navbar-expand">
      <div class="topbar-menu">
        <ul class="navbar-nav align-items-center">
          <li class="nav-item">
            <a href="javascript:;" (click)="OnToggleSideBar()" pRipple class="nav-link">
              <i class="fas fa-bars"></i>
            </a>
          </li>
          <li class="nav-item" style="width: 180px" *ngIf="isAdmin">
            <app-admin-select-agent-form
              *ngIf="isAdmin"
              [(ngModel)]="currentAgent"
              (agentChange)="selectAgentChange($event)"
            >
            </app-admin-select-agent-form>
          </li>
        </ul>
      </div>
      <div class="topbar-menu ms-auto">
        <ul class="navbar-nav align-items-center">
          <li
            class="d-none d-lg-block nav-item"
            [appTooltip]="'CHANGE_LANGUAGE' | translate"
            placement="bottom"
          >
            <a pRipple class="nav-link" (click)="svLanguage.openChooseLanguage()">
              <img [src]="svLanguage.getLang().image" height="18px" alt />
            </a>
          </li>

          <li class="d-none d-lg-block nav-item" placement="bottom" *ngIf="currentAgent">
            <a pRipple class="nav-link text-primary">
              <!-- {{currentAgent?.currency || 'THB'}} -->
              <i class="bi bi-wallet2 me-2"></i>
              {{ currentAgent?.credit_remaining || 0 | number : ".2-2" }}
              {{ currentAgent?.currency || "THB" }}
            </a>
          </li>

          <li class="d-none d-lg-block nav-item">
            <a (click)="onChangeTheme()" pRipple class="nav-link">
              <i *ngIf="darkTheme" class="bi bi-cloud-moon-fill"></i>
              <i *ngIf="!darkTheme" class="bi bi-sun"></i>
            </a>
          </li>
          <li class="d-none d-lg-block nav-item">
            <a
              href="javascript:;"
              pRipple
              class="nav-link"
              style="overflow: inherit"
              data-bs-toggle="offcanvas"
              data-bs-target="#alertModal"
              aria-controls="offcanvasRight"
            >
              <i class="bi bi-bell"></i>
              <span
                *ngIf="newNotiTotal > 0"
                class="position-absolute top-0 start-100 translate-middle p-2 bg-danger rounded-circle fa-fade fa-sm"
              >
                <span class="visually-hidden">New alerts</span>
              </span>
            </a>
          </li>
        </ul>
      </div>
      <div class="user-dropdown btn-group ms-3">
        <a href="javascript:;" pRipple class="d-flex" data-bs-toggle="dropdown">
          <img *ngIf="userProile?.user?.image" [src]="userProile?.user?.image | imgHost" alt />
          <img *ngIf="!userProile?.user?.image" src="/assets/user.png" alt />
          <div class="user-info ps-2 d-none d-lg-block">
            <p class="mb-0">{{ currentUser?.Username }}</p>
            <p
              class="mb-0 text-muted"
              style="width: 120px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis"
            >
              <small>{{ currentUser.Role }}</small>
            </p>
          </div>
        </a>
        <ul class="dropdown-menu dropdown-menu-end shadow">
          <li>
            <a
              [routerLink]="['', AppPath.profile, ProfilePath.detail]"
              pRipple
              class="dropdown-item"
            >
              <i class="bi bi-person-fill me-2"></i> {{ "PROFILE" | translate }}
            </a>
          </li>
          <li>
            <a
              pRipple
              class="dropdown-item"
              data-bs-toggle="offcanvas"
              data-bs-target="#AllLink"
              aria-controls="offcanvasRight"
            >
              <i class="bi bi-folder-symlink me-2"></i> {{ "VARIOUS_LINKS" | translate }}
            </a>
          </li>
          <li>
            <a
              [routerLink]="['', AppPath.profile, ProfilePath.login]"
              pRipple
              class="dropdown-item"
            >
              <i class="bi bi-box-arrow-in-right me-2"></i> {{ "LOGIN_HISTORY" | translate }}
            </a>
          </li>
          <li>
            <a
              [routerLink]="['', AppPath.profile, ProfilePath.changePassword]"
              Ripple
              class="dropdown-item"
            >
              <i class="bi bi-box-arrow-in-right me-2"></i> {{ "CHANGE_PASSWORD" | translate }}
            </a>
          </li>
          <li class="dropdown-divider"></li>
          <li class="d-block d-lg-none">
            <a class="dropdown-item" pRipple (click)="svLanguage.openChooseLanguage()">
              <i class="fas fa-globe"></i> {{ "CHANGE_LANGUAGE" | translate }}
            </a>
          </li>
          <li class="d-block d-lg-none">
            <a class="dropdown-item" pRipple (click)="onChangeTheme()">
              <i *ngIf="darkTheme" class="bi bi-cloud-moon-fill"></i>
              <i *ngIf="!darkTheme" class="bi bi-sun"></i> {{ "THEME" | translate }}
            </a>
          </li>
          <li class="d-block d-lg-none">
            <a
              class="dropdown-item"
              pRipple
              data-bs-toggle="offcanvas"
              data-bs-target="#alertModal"
            >
              <i class="bi bi-bell"></i> {{ "NOTIFICATION" | translate }}
            </a>
          </li>
          <li class="d-block d-lg-none dropdown-divider"></li>
          <li>
            <a href="javascript:;" pRipple class="dropdown-item" (click)="onLogout()">
              <i class="me-2 fas fa-power-off"></i> {{ "LOG_OUT" | translate }}</a
            >
          </li>
        </ul>
      </div>
    </nav>
  </div>
</header>

<div
  class="overlay-toggle-sidebar"
  (click)="OnToggleSideBar()"
  [ngClass]="{ 'overlay-open': sidebarOpen }"
></div>

<div class="sidebar-layout bg-body shadow-sm" [ngClass]="{ 'sidebar-open': sidebarOpen }">
  <a class="sidebar-header text-center" [routerLink]="['']">
    <img class="brand-logo img-shadow" alt="brand-logo" height="55px" src="{{ Config.LogoDark }}" />
    <img class="brand-logo-w img-shadow" alt="brand-logo" height="55px" src="{{ Config.Logo }}" />
  </a>
  <div class="sidebar-content" [perfectScrollbar]="{}">
    <div class="pt-2 pb-5 px-3" id="accordion-sidebar">
      <ul class="list-unstyled sidebar-menu-group">
        <ng-container *ngFor="let item of sidebarMenu; let i = index">
          <li *ngIf="item.type === 'router'" class="menu-router">
            <a
              class="link-dark"
              href="javascript:;"
              [routerLink]="item.link"
              routerLinkActive="active"
              pRipple
            >
              <ng-container *ngIf="!item.imageSrc">
                <i [class]="'fix-icon ' + item.iconClass"> {{ item.iconName }} </i>
              </ng-container>
              <ng-container *ngIf="item.imageSrc">
                <img [src]="item.imageSrc" width="15px" class="me-2 rounded-circle" alt />
              </ng-container>

              <span>
                {{ item.name | translate }}

                <span
                  *ngIf="item.badgesName && Badges[item.badgesName]"
                  class="badge bg-danger rounded-pill"
                >
                  {{ Badges[item.badgesName] }}
                </span>

                <ng-container *ngIf="item.badgesName === 'WithdrawAuto'">
                  <span
                    class="badge bg-info rounded-pill me-1"
                    *ngIf="Badges.WithdrawPending !== 0"
                  >
                    {{ Badges.WithdrawPending }}
                  </span>
                  <span class="badge bg-danger rounded-pill" *ngIf="Badges.WithdrawFailed !== 0">
                    {{ Badges.WithdrawFailed }}
                  </span>
                </ng-container>

                <span *ngIf="item.realTimeWork">
                  <ng-container *ngIf="item.realTimeWork === 'LogOnline'">
                    <i *ngIf="LogOnline" class="bi bi-arrow-left-right"></i>
                  </ng-container>
                  <ng-container *ngIf="item.realTimeWork === 'TransferOnline'">
                    <i *ngIf="TransferOnline" class="bi bi-arrow-left-right"></i>
                  </ng-container>
                </span>
              </span>
            </a>
          </li>

          <li *ngIf="item.type === 'header'" class="menu-header">
            <div class="header-title">
              <span>{{ item.prefixName }} {{ item.name | translate }}</span>
            </div>
          </li>

          <li *ngIf="item.type === 'menu'" class="menu-list">
            <a
              class="link-dark menu-list-label"
              href="#collapse-menu-{{ i }}"
              data-bs-toggle="collapse"
              [attr.aria-expanded]="item.expanded ? true : false"
              pRipple
            >
              <ng-container *ngIf="!item.imageSrc">
                <i [class]="'fix-icon ' + item.iconClass"> {{ item.iconName }} </i>
              </ng-container>
              <ng-container *ngIf="item.imageSrc">
                <img [src]="item.imageSrc" width="15px" class="me-2 rounded-circle" alt />
              </ng-container>

              <span>
                {{ item.name | translate }}
                <span
                  *ngIf="item.badgesName && Badges[item.badgesName]"
                  class="badge bg-danger rounded-pill"
                >
                  {{ Badges[item.badgesName] }}
                </span>
              </span>
            </a>
            <ul
              id="collapse-menu-{{ i }}"
              class="list-unstyled sidebar-menu-collapse collapse"
              data-bs-parent="#accordion-sidebar"
              [class.show]="item.expanded"
            >
              <ng-container *ngFor="let menu of item.menuList; let j = index">
                <li>
                  <a
                    class="link-dark"
                    href="javascript:;"
                    [routerLink]="menu.link"
                    routerLinkActive="active"
                    pRipple
                  >
                    <i class="far fa-circle fa-xs" style="width: 12px"></i>
                    <span class="me-2"> {{ menu.name | translate }} </span>
                    <span
                      *ngIf="menu.badgesName && Badges[menu.badgesName]"
                      class="badge bg-danger rounded-pill"
                    >
                      {{ +Badges[menu.badgesName] }}
                    </span>
                  </a>
                </li>
              </ng-container>
            </ul>
          </li>
        </ng-container>
      </ul>
      <hr />
      <div class="bg-black-op text-center">
        <p>{{ "THANK_YOU_USING_SERVICE" | translate }}</p>
        <small class="text-uppercase"> {{ Config?.createBy?.name || "GOODGAME66" }}</small>
      </div>
      <div style="height: 150px"></div>
    </div>
  </div>
</div>

<div class="page-wrapper" [ngClass]="{ active: sidebarOpen }">
  <div class="page-content">
    <div class="row mb-2">
      <div class="col-12">
        <div class="box-message">
          <div class="nav-message float-start">
            <i class="bi bi-envelope"></i> {{ "MESSAGE" | translate }}
          </div>
          <div class="p-1">
            <marquee
              behavior="scroll"
              direction="left"
              onmouseover="this.stop()"
              scrolldelay="120"
              onmouseout="this.start()"
              class="w-100"
            >
              {{ "HI" | translate }}!!
              {{ "WELCOME_TO_WEBSITE_NAME" | translate : { website_name: Config.YourBand.en } }}
              🤟🤟🤟
            </marquee>
          </div>
        </div>
      </div>
    </div>
    <router-outlet></router-outlet>
    <div class="text-end pt-4 pb-4 opacity-50">
      Copyright © 2021. All Right Reserved. ({{ Config?.createBy?.name || "GOODGAME66" }}
      {{ svApp.version }})
    </div>
  </div>
</div>

<app-alert-modal [(newItemTotal)]="newNotiTotal"></app-alert-modal>

<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="AllLink"
  aria-labelledby="offcanvasRightLabel"
>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="offcanvasRightLabel">
      {{ "LINKS_FOR_USE" | translate }}
    </h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>
  <div class="offcanvas-body">
    <div class="highlight">
      <div class="mb-3">
        {{ "LINK_TO_PLAY" | translate }}
        <code data-lang="html">
          {{ " https://{host}/login?a={agent_code}" }}
        </code>
      </div>
      <div class="mb-3">
        {{ "LINK_TO_APPLY_FROM_MAIN_PAGE" | translate }}
        <code data-lang="html">
          {{ "https://{host}/register?a={agent_code}" }}
        </code>
      </div>
      <div class="mb-3">
        {{ "LINK_TO_APPLY_FROM_LINE" | translate }}
        <code data-lang="html">
          {{ "https://{host}/register?referer=LINE&agun={agent_code}" }}
        </code>
      </div>
      <div class="mb-3">
        {{ "LOGIN_LINK_FOR_REDIRECT_TOKEN" | translate }}
        <code data-lang="html">
          {{ "https://{host}/redirect/token?t={token}" }}
        </code>
      </div>
      <div class="mb-3">
        {{ "LOGIN_LINK_FOR_REDIRECT_LOGIN" | translate }}
        <code data-lang="html">
          {{ "https://{host}/redirect/pass-login?username={user}&password={pass}" }}
        </code>
      </div>
    </div>
  </div>
</div>

<div class="d-none">
  <audio *ngFor="let item of currentSoundSetting | keyvalue" [id]="$any(item.value).name">
    <source [src]="$any(item.value).path" />
  </audio>
</div>

<button
  type="button"
  class="btn d-none"
  data-bs-target="#memberCreditFormOffcanvas"
  data-bs-toggle="offcanvas"
  id="btn-open-member-credit-form"
>
  open memberCreditFormOffcanvas
</button>
<app-credit-form-offcanvas
  [id]="'memberCreditFormOffcanvas'"
  [isAdd]="memberCreditFormData.is_add"
  [memberId]="memberCreditFormData.member_id"
>
</app-credit-form-offcanvas>

<button
  type="button"
  class="btn d-none"
  data-bs-target="#mainClearTurnoverMemberOffCanvas"
  data-bs-toggle="offcanvas"
  id="btn-open-clear-turnover-member"
>
  open memberCreditFormOffcanvas
</button>
